export const isMajorVersionMatch = (versionA: string, versionB: string): boolean => {
  const getMajor = (v: string): string | null => {
    const match = v.match(/^(\d+)/);
    return match ? match[1] : null;
  };
  return getMajor(versionA) !== null && getMajor(versionA) === getMajor(versionB);
};
